/**
 * FAQ相关API
 */
import http from './http'

export default class FaqApi {
    static getList(userId) {
        return http.httpGet('faq/list', {userId});
    }

    static getItem(id) {
        return http.httpGet('faq', {id});
    }
    static classify(params) {
        return http.httpGet('faq/classify', params);
    }

}



// WEBPACK FOOTER //
// ./app/api/faq.api.js